// Configurazioni contestuali della videoconsulenza: un'unica agenda, moduli personalizzati
// in base alla pagina di provenienza. La provenienza viene persistita nel backend.

export const CONSULTATION_TYPE = "videoconsulenza conoscitiva gratuita";
export const DURATION_MINUTES = 20;

export const BOOKING_CONFIGS = {
  general: {
    title: "Consulenza conoscitiva A.C. HUB",
    description:
      "Raccontaci il tuo obiettivo immobiliare. Ti aiuteremo a individuare il percorso più adatto.",
    showProtocolSelection: true,
    unsureOption: "Non so ancora quale percorso scegliere",
  },
  "ac-start": {
    title: "Consulenza preliminare AC START",
    description: "Un primo confronto per conoscere il tuo immobile e valutare le tue esigenze.",
    protocolLabel: "AC START",
    questions: [
      {
        key: "selected_goal",
        label: "Qual è la tua esigenza principale?",
        options: [
          "Conoscere il valore dell'immobile.",
          "Approfondire la documentazione.",
          "Valutare possibili interventi.",
          "Orientarmi prima di una decisione.",
        ],
      },
      {
        key: "selected_type",
        label: "Tipologia di immobile",
        options: ["Appartamento.", "Casa / Villa.", "Altro."],
      },
    ],
  },
  "ac-hunt": {
    title: "Consulenza preliminare AC HUNT",
    description:
      "Parliamo del tuo progetto di acquisto e delle caratteristiche dell'immobile che cerchi.",
    protocolLabel: "AC HUNT",
    questions: [
      {
        key: "selected_goal",
        label: "Che tipo di acquisto stai valutando?",
        options: ["Prima casa.", "Cambio abitazione.", "Seconda casa.", "Altro."],
      },
    ],
  },
  "ac-select": {
    title: "Consulenza preliminare AC SELECT",
    description: "Un primo confronto sul tuo immobile e sugli obiettivi di vendita.",
    protocolLabel: "AC SELECT",
    questions: [
      {
        key: "selected_goal",
        label: "Qual è il tuo obiettivo?",
        options: ["Vendere a breve.", "Valutare una possibile vendita.", "Valorizzare prima di vendere.", "Altro."],
      },
    ],
  },
  "ac-invest": {
    title: "Consulenza preliminare AC INVEST",
    description: "Confrontiamoci sull'operazione immobiliare che stai valutando.",
    protocolLabel: "AC INVEST",
    questions: [
      {
        key: "selected_goal",
        label: "Quale operazione ti interessa?",
        options: [
          "Acquisto e rivendita.",
          "Immobile da mettere a reddito.",
          "Acquisto e valorizzazione.",
          "Opportunità da analizzare.",
        ],
      },
    ],
  },
  "ac-management": {
    title: "Consulenza preliminare AC MANAGEMENT",
    description: "Parliamo dell'intervento che desideri realizzare e delle tue esigenze.",
    protocolLabel: "AC MANAGEMENT",
    questions: [
      {
        key: "selected_goal",
        label: "Quale intervento stai valutando?",
        options: ["Ristrutturazione completa.", "Riqualificazione.", "Lavori parziali.", "Valutazione preliminare."],
      },
    ],
  },
};

export function bookingContextFromPath() {
  const path = window.location.pathname;
  if (path.includes("/protocollo/")) {
    const slug = path.split("/").pop();
    if (BOOKING_CONFIGS[slug]) {
      return { configKey: slug, bookingSource: slug, config: BOOKING_CONFIGS[slug] };
    }
    return { configKey: "general", bookingSource: "homepage", config: BOOKING_CONFIGS.general };
  }
  return { configKey: "general", bookingSource: "homepage", config: BOOKING_CONFIGS.general };
}

export function protocolInterestLabel(goal) {
  if (!goal || goal === "general") return "GENERAL";
  return goal.toUpperCase().replace(/-/g, "_");
}
